
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import item from './resumen-item.vue';
    import { Wait } from '@/__env/ext';
    import { ControladorSeccion } from '@/views/a-publicaciones-ml/pc/lista/controlador';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            item
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        @Prop()
        public Estado: ControladorSeccion;

        public get Valores() { return this.Controlador.Estadistica.Valores; }
        public get Estadistica() { return this.Controlador.Estadistica.Estadistica; }
        public get EstadoSeleccionado() { return this.Controlador.Estadistica.EstadoSeleccionado; }
        public Cargando: boolean = true;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {
            this.Eventos.push( this.Controlador.Buscador.onActualizar.subscribe( () => { this.Iniciar(); } ) );
            this.Eventos.push( this.Controlador.onRecargarEstadistica.subscribe( () => { this.Iniciar( true ); } ) );
            await this.Iniciar();
        }

        async Iniciar( forzar: boolean = false )
        {
            this.Cargando = true;
            await this.Controlador.Estadistica.Iniciar( forzar );
            this.Cargando = false;
        }
    }
